// extracted by mini-css-extract-plugin
export var heroImage = "_gn-1";
export var modal = "_gn-0";